const UNNAMED_GROUP = "Other plans";

/**
 * Plans keyed by their selling plan group's name, in first-seen order. A shop
 * running more than one subscription app often has plans with the same name
 * in each ("Monthly"), and the group is the only thing telling them apart.
 */
export const groupPlansByName = <Plan extends { groupName: string | null }>(
	plans: readonly Plan[],
): Map<string, Plan[]> => {
	const groups = new Map<string, Plan[]>();
	for (const plan of plans) {
		const name = plan.groupName ?? UNNAMED_GROUP;
		groups.set(name, [...(groups.get(name) ?? []), plan]);
	}
	return groups;
};
